<template>
  <div class="mime">
   <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.true') }}</option>
      <option :value='false'>{{ $t('root.filters.false') }}</option>
    </select>

    <label>{{ $t('root.filters.mime') }}</label>
    <multi-select v-model='selectedTypes' :options='types' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../_multi_select'
  import {PDF_MIME_TYPE, IMG_MIME_TYPE, DOC_MIME_TYPE, ZIP_MIME_TYPE, XLS_MIME_TYPE, PPT_MIME_TYPE, VIDEO_MIME_TYPE} from '../../../../mime_type'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        predicate: true,
        selectedTypes: [],
      }
    },
    computed: {
      types() {
        return [
          { name: 'pdf', id: 'pdf' },
          { name: 'image', id: 'image' },
          { name: 'doc', id: 'doc' },
          { name: 'zip', id: 'zip' },
          { name: 'xls', id: 'xls' },
          { name: 'ppt', id: 'ppt' },
          { name: 'video', id: 'video' },
        ]
      },
      strToMime() {
        return {
          pdf: PDF_MIME_TYPE,
          image: IMG_MIME_TYPE,
          doc: DOC_MIME_TYPE,
          zip: ZIP_MIME_TYPE,
          xls: XLS_MIME_TYPE,
          ppt: PPT_MIME_TYPE,
          video: VIDEO_MIME_TYPE,
        }
      },
      selectedTypeIds() {
        return this.selectedTypes.flatMap(c => this.strToMime[c.id])
      },
      predicateQuery() {
        return this.predicate ? 'filters[mime_type_in]' : 'filters[mime_type_not_in]'
      }
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        delete newQuery['filters[mime_type_in]']
        delete newQuery['filters[mime_type_not_in]']

        newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, [this.predicateQuery]: this.selectedTypeIds })

        this.$router.push({ query: newQuery })
      },
    }
  }
</script>

<style lang="sass" scoped>
.mime
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
</style>
